/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

/* global I18n */

import React, { useState, useEffect } from "react";

import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import BlockIcon from "@material-ui/icons/Block";
import IconButton from "@material-ui/core/IconButton";

import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";

import { useDebounce } from "@hooks";

const CustomTooltipp = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: "1.2rem",
  },
}));

const BadgeAnswered = styled("span")(() => ({
  backgroundColor: "#3C631D",
  alignSelf: "baseline",
  fontSize: "1.2rem",
}));

const BadgeVotes = styled("span")(() => ({
  backgroundColor: "#445788",
  alignSelf: "baseline",
  fontSize: "1.2rem",
}));

const useClasses = makeStyles({
  focus: {
    "&:focus": {
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineColor: "#000000",
    },
  },
});

type TProps = {
  voteCount: number;
  initLiked: boolean;
  answered: boolean;
  disabled: boolean;
  toggleLike: (val: boolean) => void;
};

function QuestionVoteitem({
  voteCount,
  initLiked,
  answered,
  disabled,
  toggleLike,
}: TProps) {
  const [isLiked, setIsLiked] = useState(initLiked);
  const debouncedLike = useDebounce(isLiked, 2000);
  const classes = useClasses();

  useEffect(() => {
    toggleLike(debouncedLike);
  }, [debouncedLike]);

  const buttonTitle = disabled
    ? I18n.t("questions.disabled_vote")
    : isLiked
      ? I18n.t("questions.can_unvote")
      : I18n.t("questions.can_vote");

  const showVotes = () => {
    return (
      !answered && (
        <Stack direction="row" gap={0.5}>
          <CustomTooltipp
            arrow
            enterDelay={2000}
            placement="top"
            title={buttonTitle}
            describeChild={false}
          >
            <span>
              <IconButton
                className={classes.focus}
                onClick={() => {
                  setIsLiked(!isLiked);
                }}
                disabled={disabled}
                size="small"
                aria-label={I18n.t("questions.like")}
                aria-pressed={isLiked}
                disableRipple
              >
                {!disabled ? (
                  isLiked ? (
                    <ThumbUpIcon />
                  ) : (
                    <ThumbUpOutlinedIcon />
                  )
                ) : (
                  <BlockIcon />
                )}
              </IconButton>
            </span>
          </CustomTooltipp>
          <BadgeVotes
            aria-label={`${voteCount} ${I18n.t("questions.likes")}`}
            aria-live="polite"
            className="badge"
          >
            {voteCount}
          </BadgeVotes>
        </Stack>
      )
    );
  };

  const showAnswered = () => {
    return (
      answered && (
        <BadgeAnswered className="label">
          {I18n.t("questions.answered")}
        </BadgeAnswered>
      )
    );
  };
  return (
    <>
      {showVotes()}
      {showAnswered()}
    </>
  );
}

export default QuestionVoteitem;
